'use client';

import { useRef } from 'react';

/**
 * Which fields the user has typed in, so an untouched field can calculate on its greyed default
 * while one deliberately cleared still raises its error. An empty value alone cannot tell the two
 * apart - both are `''` - and only `onChange` distinguishes them.
 *
 * A ref rather than state: nothing renders from this, and a touch must not trigger one.
 */
export const useTouchedFields = () => {
  const touched = useRef<Set<string>>(new Set());

  return {
    markTouched: (label: string) => touched.current.add(label),
    isTouched: (label: string) => touched.current.has(label),
    resetTouched: () => {
      touched.current = new Set();
    },
  };
};
